import React, { FC } from 'react';
import { Box } from '@mui/material';
import warning from '@ingka/ssr-icon/paths/notice-red-small';

const NegativeIcon: FC = () => (
  <Box sx={{ display: 'flex', alignItems: 'center' }}>
    <svg
      width="20"
      height="20"
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {warning() as unknown as React.ReactNode}
    </svg>
  </Box>
);

export default NegativeIcon;
